module.exports = __webpack_public_path__ + "static/patricia-korthmcdonnell-400w-103018-d97e5a0ccdb860286cf325d4ed3bc57e.jpg";